import type { Variants } from "motion/react";
import { transitionDurations } from "@huub-web/ui/theme/transitionDurations";

export const checkIconVariants: Variants = {
  unchecked: {
    scale: 1,
    transition: {
      duration: transitionDurations.s,
      ease: "easeOut",
    },
  },
  checked: {
    scale: [1, 1.6, 1],
    transition: {
      duration: transitionDurations.s,
      ease: "easeInOut",
    },
  },
};
